import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'dsm-root-route',
  templateUrl: './root-route.component.html',
  styleUrls: ['root-route.component.scss']
})
export class RootRouteComponent {
  public selectedTabIndex = 0;

  public goToIntegrationsTab(): void {
    this.selectedTabIndex = 2;
  }
}
